define('Magento_Catalog/js/modal-add-to-cart',[
    'uiComponent',
    'Magento_Customer/js/customer-data',
    'jquery',
    'ko',
    'underscore',
    'Magento_Ui/js/modal/modal',
    'Magento_Catalog/js/vendor/owl.carousel.min'
], function (Component, customerData, $, ko, _, modal) {
    'use strict';

    return Component.extend({
        defaults: {
            modalOptions: {
                type: 'popup',
                modalClass: 'add-to-cart-modal',
                buttons: [],
                responsive: true,
                innerScroll: true,
            },
            popupElement: '.add-to-cart-popup',
            productImage: '.add-to-cart-popup .product-image',
            minicart: '[data-block="minicart"]',
            carousel: '.add-to-cart-popup .owl-carousel',
            crossSellContainer: '.add-to-cart-modal .cross-sell-wrapper',
            previousCount: 0,
            popupTitle: ko.observable('%1 Item Added to Your Cart'),
            popupSubtotalTitle: ko.observable('Cart Subtotal (%1 items):'),
            popupSubtotalValue: ko.observable(''),
            popupProductPrice: ko.observable(''),
            popupProductImageSrc: ko.observable(''),
            popupProductDisplayName: ko.observable(''),
            popupProductQty: ko.observable(''),
            popupProductName: ko.observable(''),
            addToCartEvent: ko.observable(false),
            popup: ''
        },

        initialize: function () {
            this._super();

            var self = this,
                cartData = customerData.get('cart');

            $(self.minicart).on('contentLoading', function () {
                self.addToCartEvent(true);
                self.previousCount = cartData().summary_count || 0;

                cartData.subscribe(function (updatedCart) {
                    if (self.addToCartEvent()) {
                        let addedItem = updatedCart.summary_count - self.previousCount,
                            lastAddedProductId = updatedCart.last_added_product_id,
                            currentElement = updatedCart.items.find((item) => item.product_id === lastAddedProductId);
                        self.popupTitle(self.popupTitle().replace('%1', addedItem));
                        self.popupSubtotalTitle(self.popupSubtotalTitle().replace('%1', updatedCart.summary_count));
                        self.popupSubtotalValue('$' + parseFloat(updatedCart.subtotalAmount).toFixed(2));
                        self.popupProductPrice('$' + parseFloat(currentElement.product_price_value * addedItem).toFixed(2));
                        self.popupProductDisplayName(currentElement.displayname);
                        self.popupProductName(currentElement.product_name);
                        self.popupProductQty(addedItem);
                        self.popupProductImageSrc(currentElement.product_image.src);
                        self.modalOptions.title = self.popupTitle();

                        if (self.popup === '') { // Init modal only if it was not previously added
                            self.popup = modal(self.modalOptions, self.popupElement);
                        }

                        self.popup.openModal();

                        $(self.carousel).owlCarousel({
                            loop: false,
                            margin: 10,
                            nav: true,
                            dots: false,
                            responsive:{
                                0:{
                                    items:1
                                },
                                600:{
                                    items:3
                                },
                                1000:{
                                    items:4
                                }
                            }
                        })
                        self.addToCartEvent(false);
                    }
                }, this);
            });
        },

        closeModal: function () {
            this.popup.closeModal();
        }
    });
});

